var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    fillRule: "evenodd",
    d: "M5.898 12.299c-.827 0-1.497.67-1.497 1.497v9.215c0 .827.67 1.498 1.497 1.498h16.204c.827 0 1.497-.67 1.497-1.498v-9.215c0-.827-.67-1.497-1.497-1.497H5.898zm-3.45 1.497c0-1.905 1.545-3.45 3.45-3.45h16.204c1.905 0 3.45 1.545 3.45 3.45v9.215c0 1.906-1.545 3.45-3.45 3.45H5.898c-1.905 0-3.45-1.544-3.45-3.45v-9.215z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    fillRule: "evenodd",
    d: "M14 3.491c-2.706 0-4.899 2.194-4.899 4.9v2.226c0 .54-.437.976-.976.976-.54 0-.976-.437-.976-.976V8.39c0-3.784 3.067-6.851 6.851-6.851s6.852 3.067 6.852 6.851v2.227c0 .54-.437.976-.976.976-.54 0-.977-.437-.977-.976V8.39c0-2.705-2.193-4.899-4.899-4.899z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountPrivacy);
export default __webpack_public_path__ + "static/media/account-privacy.eb947e0d9f9b8ac2355565bc64f9d1b1.svg";
export { ForwardRef as ReactComponent };